import React, { useContext, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";
import { CartContext } from "./CartContext";
import GameCard from "./GameCard";
import GamePlayer from "./GamePlayer";

const categories = ["All games", "Puzzle", "Arcade", "Strategy", "Action"];

function Main() {
  const [category, setCategory] = useState("All games");
  const [playing, setPlaying] = useState(null);
  const { progress, unlocks } = useContext(CartContext);
  const games = useMemo(() => productData.filter((game) => game.featured && (category === "All games" || game.category === category)), [category]);
  const played = Object.entries(progress).sort(([, a], [, b]) => String(b.updatedAt).localeCompare(String(a.updatedAt))).slice(0, 3);

  return <main className="main home-page">
    <section className="hero page-shell">
      <span className="hero__pill"><i /> {productData.length} distinct games · playable in your browser</span>
      <h1>Try <span>small games</span>,<br />unlock bigger worlds.</h1>
      <p className="hero__copy">Pick a game and play instantly—no account, download or waiting. Purchase is a local storefront demonstration that unlocks expanded levels on this browser.</p>
      <div className="hero__actions"><Link className="button button--large" to="/shop">Browse games <span>→</span></Link><button className="button button--quiet button--large" onClick={() => setPlaying(productData[0])}>Play a demo</button></div>
      <div className="trust-pills"><span>✦ Play instantly</span><span>♡ Save locally</span><span>▱ Demo checkout</span><span>✓ Unlock locally</span></div>
    </section>

    <section className="catalog-section page-shell" aria-labelledby="instant-games">
      <div className="section-heading"><div><p className="eyebrow">Instant browser play</p><h2 id="instant-games">Featured games</h2></div><Link to="/shop">Browse all {productData.length} →</Link></div>
      <div className="filter-tabs" role="group" aria-label="Filter featured games">{categories.map((item) => <button type="button" key={item} className={category === item ? "is-active" : ""} onClick={() => setCategory(item)}>{item}</button>)}</div>
      {games.length ? <div className="game-grid game-grid--featured">{games.map((game) => <GameCard key={game.id} game={game} onPlay={setPlaying} compact />)}</div> : <div className="empty-state"><h3>No featured games in this category.</h3><button className="button button--quiet" onClick={() => setCategory("All games")}>Show all games</button></div>}
    </section>

    <section className="progress-section">
      <div className="page-shell progress-layout">
        <div><p className="eyebrow eyebrow--light">This browser</p><h2>Your arcade, without an account.</h2><p>Scores, favourites, demo orders and unlocked editions stay in localStorage on this device. Nothing is presented as an online rank or live purchase record.</p><Link className="button button--light" to="/shop">Choose your next run</Link></div>
        <div className="local-progress-card">
          <div className="progress-card__top"><div><span>LOCAL LIBRARY</span><strong>{unlocks.length}</strong><small>editions unlocked</small></div><div><span>GAMES TRIED</span><strong>{Object.keys(progress).length}</strong><small>on this browser</small></div></div>
          <h3>Recent runs</h3>
          {played.length ? played.map(([id, record]) => { const game = productData.find((item) => item.id === Number(id)); return game ? <Link className="recent-run" key={id} to={`/product/${id}`}><span>{game.name}</span><strong>{record.bestScore} pts</strong></Link> : null; }) : <p className="muted-light">Finish a demo and your best run will appear here.</p>}
        </div>
      </div>
    </section>

    <section className="steps-section page-shell">
      <div className="section-heading"><div><p className="eyebrow">Simple by design</p><h2>From curiosity to full play</h2></div></div>
      <div className="steps-grid">{[
        ["01", "Try", "Open any game and finish its real, playable demo."],
        ["02", "Choose", "Compare the exact demo boundary with the full-edition unlock."],
        ["03", "Unlock", "Complete a clearly marked simulation and play the expanded configuration locally."],
      ].map(([number, title, copy]) => <article key={number}><span>{number}</span><h3>{title}</h3><p>{copy}</p></article>)}</div>
    </section>
    {playing && <GamePlayer game={playing} onClose={() => setPlaying(null)} />}
  </main>;
}

export default Main;
